import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/search.png'
import _imports_1 from '../../../assets/icons/add.png'
import _imports_2 from '../../../assets/icons/list.png'


const _withScopeId = n => (_pushScopeId("data-v-617d0352"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-container" }
const _hoisted_3 = {
  key: 0,
  class: "search-area"
}
const _hoisted_4 = {
  key: 1,
  class: "sidebar-actions"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "chats" }, "Projeler", -1))
const _hoisted_6 = { class: "chats-container" }
const _hoisted_7 = {
  key: 0,
  class: "text-left text-gray-400"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "processor-container"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "processor" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }

import { useStore } from "vuex"
import { computed, ref } from "vue"
import { useGetAllProjects } from "@/composables/aiChatFunctions"
import TeleportsAcMediumModal from "../../reusable/teleports/acMediumModal.vue"
import ManageProjectMembers from "./manageProjectMembers.vue"
import type { AICollabProject } from "@/types"

export default /*#__PURE__*/_defineComponent({
  __name: 'collaborativeSidebar',
  emits: ['projectChanged', 'createNewProject'],
  setup(__props, { expose: __expose, emit: __emit }) {


const emit = __emit
const store = useStore()

const isEditingProjectMembers = ref(false)
const searchAreaDisplayed = ref(false)
const searchTerm = ref('')

const selectedProject = computed(() => store.getters['ai/selectedProject']);
const userProfile = computed(() => store.getters['user/userProfile']);

const {projects, isLoadingProjects, getProjects} = useGetAllProjects(userProfile.value.uid)

const filteredProjects = computed(() => {
    if (searchTerm.value === '') {
        return projects.value
    }
    return projects.value.filter((session) => {
        return session.name.toLowerCase().includes(searchTerm.value.toLowerCase())
    })
})

const refreshProjects = async () => {
    await getProjects()
}

const handleCreateNewProject = async () => {
    emit('createNewProject')
}

const projectChanged = (project: AICollabProject) => {
    emit('projectChanged', project)
}

__expose({
    refreshProjects
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (searchAreaDisplayed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              onBlur: _cache[0] || (_cache[0] = ($event: any) => {searchTerm.value = ''; searchAreaDisplayed.value = false}),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event)),
              type: "text",
              placeholder: "Projelerde Ara"
            }, null, 544), [
              [_vModelText, searchTerm.value]
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchAreaDisplayed.value = !searchAreaDisplayed.value)),
              class: "sidebar-action-icon",
              src: _imports_0,
              alt: "Search Chats"
            }),
            (userProfile.value.allowsEdit)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onClick: handleCreateNewProject,
                  class: "sidebar-action-icon",
                  src: _imports_1,
                  alt: "Add New Chat"
                }))
              : _createCommentVNode("", true)
          ])),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (filteredProjects.value.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Hiçbir proje bulunamadı. "))
          : (!_unref(isLoadingProjects) && filteredProjects.value.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProjects.value, (project) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["flex items-center justify-between", { 'selected': project.id === selectedProject.value?.id }]),
                    onClick: ($event: any) => (projectChanged(project)),
                    key: project.id
                  }, [
                    _createTextVNode(_toDisplayString(project.name) + " ", 1),
                    (project.isProcessingInfoBase)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                      : _createCommentVNode("", true),
                    (project.id === selectedProject.value?.id && userProfile.value.allowsEdit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                          _createElementVNode("img", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (isEditingProjectMembers.value = true)),
                            class: "sidebar-action-icon",
                            src: _imports_2,
                            alt: "Manage Project Members"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_9))
                }), 128))
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Teleport, { to: ".global-container" }, [
          (isEditingProjectMembers.value)
            ? (_openBlock(), _createBlock(TeleportsAcMediumModal, {
                key: 0,
                title: "Proje Üyelerini Düzenle",
                width: "50vw",
                height: "60vh",
                onModalClosed: _cache[4] || (_cache[4] = ($event: any) => {isEditingProjectMembers.value = false; })
              }, {
                default: _withCtx(() => [
                  _createVNode(ManageProjectMembers)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    })
  ]))
}
}

})